import { Box, styled } from '@mui/material';

export const StyledBox = styled(Box)`
  flex-direction: column;
  position: relative;
  width: 100%;
  z-index: 1;
`;
